import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const Register = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    phone: '',
    password: '',
    restaurant_name: '',
    business_type: 'restaurant',
    role: 'restaurant_owner',
  });
  const [error, setError] = useState('');
  const [matchedFields, setMatchedFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const fieldHasError = (key) => matchedFields.includes(key);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Sahə dəyişəndə onun xətasını təmizlə
    if (matchedFields.includes(e.target.name)) {
      setMatchedFields(matchedFields.filter((f) => f !== e.target.name));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMatchedFields([]);

    const result = await register({
      email: formData.email.trim(),
      password: formData.password,
      full_name: formData.full_name.trim(),
      phone: formData.phone.trim(),
      role: formData.role,
      restaurant_name: formData.restaurant_name.trim(),
      business_type: formData.business_type,
    });
    setLoading(false);

    if (result.success) {
      navigate('/dashboard?welcome=1');
    } else {
      setError(result.error);
      setMatchedFields(result.matched_fields || []);
    }
  };

  const inputClass = (key, base) =>
    `${base} ${fieldHasError(key)
      ? 'border-red-400 bg-red-50 focus:ring-red-500'
      : 'border-stone-300 bg-white focus:ring-emerald-500'}`;

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-emerald-50 to-stone-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-xl p-8 sm:p-10 border border-stone-200">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-emerald-100 rounded-2xl mb-3">
            <span className="text-3xl">🍽️</span>
          </div>
          <h1 className="text-3xl font-bold text-stone-900 mb-1" data-testid="register-title">
            Restoran qeydiyyatı
          </h1>
          <p className="text-stone-500 text-sm">
            Restoranınızı SmartMenyu.az platformasına əlavə edin
          </p>
        </div>

        {error && (
          <div
            className="mb-5 p-4 bg-red-50 border-l-4 border-red-500 rounded-r-lg flex items-start gap-3"
            data-testid="register-error"
          >
            <span className="text-xl leading-none">⚠️</span>
            <div className="text-sm text-red-800 font-medium">{error}</div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Ad Soyad */}
          <div>
            <label className="block text-sm font-semibold text-stone-700 mb-1.5">
              Ad Soyad <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              className={inputClass(
                'full_name',
                'w-full px-4 py-3 border rounded-xl focus:ring-2 focus:border-transparent transition'
              )}
              placeholder="Ad Soyad"
              required
              data-testid="register-fullname-input"
            />
            {fieldHasError('full_name') && (
              <p className="text-xs text-red-600 mt-1" data-testid="error-full_name">
                Bu Ad Soyad ilə artıq qeydiyyatdan keçilib
              </p>
            )}
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-semibold text-stone-700 mb-1.5">
              Email <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={inputClass(
                'email',
                'w-full px-4 py-3 border rounded-xl focus:ring-2 focus:border-transparent transition'
              )}
              placeholder="email@example.com"
              required
              data-testid="register-email-input"
            />
            {fieldHasError('email') && (
              <p className="text-xs text-red-600 mt-1" data-testid="error-email">
                Bu Email ilə artıq qeydiyyatdan keçilib
              </p>
            )}
          </div>

          {/* Telefon */}
          <div>
            <label className="block text-sm font-semibold text-stone-700 mb-1.5">
              Telefon <span className="text-red-500">*</span>
            </label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className={inputClass(
                'phone',
                'w-full px-4 py-3 border rounded-xl focus:ring-2 focus:border-transparent transition'
              )}
              placeholder="+994 XX XXX XX XX"
              required
              data-testid="register-phone-input"
            />
            {fieldHasError('phone') && (
              <p className="text-xs text-red-600 mt-1" data-testid="error-phone">
                Bu Telefon nömrəsi ilə artıq qeydiyyatdan keçilib
              </p>
            )}
          </div>

          {/* Restoran adı */}
          <div>
            <label className="block text-sm font-semibold text-stone-700 mb-1.5">
              Restoran / Cafe adı <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="restaurant_name"
              value={formData.restaurant_name}
              onChange={handleChange}
              className={inputClass(
                'restaurant_name',
                'w-full px-4 py-3 border rounded-xl focus:ring-2 focus:border-transparent transition'
              )}
              placeholder="Məs: Nezih Steak House"
              required
              data-testid="register-restaurant-input"
            />
            {fieldHasError('restaurant_name') && (
              <p className="text-xs text-red-600 mt-1" data-testid="error-restaurant_name">
                Bu Restoran/Cafe adı ilə artıq qeydiyyatdan keçilib
              </p>
            )}
          </div>

          {/* Fəaliyyət növü */}
          <div>
            <label className="block text-sm font-semibold text-stone-700 mb-1.5">
              Fəaliyyət növü <span className="text-red-500">*</span>
            </label>
            <div className="grid grid-cols-2 gap-3">
              <button
                type="button"
                onClick={() => setFormData({ ...formData, business_type: 'restaurant' })}
                className={`px-4 py-3 rounded-xl border-2 font-semibold transition text-sm ${
                  formData.business_type === 'restaurant'
                    ? 'border-emerald-600 bg-emerald-50 text-emerald-700'
                    : 'border-stone-200 bg-white text-stone-600 hover:border-stone-300'
                }`}
                data-testid="business-type-restaurant"
              >
                🍽️ Restaurant
              </button>
              <button
                type="button"
                onClick={() => setFormData({ ...formData, business_type: 'cafe' })}
                className={`px-4 py-3 rounded-xl border-2 font-semibold transition text-sm ${
                  formData.business_type === 'cafe'
                    ? 'border-emerald-600 bg-emerald-50 text-emerald-700'
                    : 'border-stone-200 bg-white text-stone-600 hover:border-stone-300'
                }`}
                data-testid="business-type-cafe"
              >
                ☕ Cafe
              </button>
            </div>
          </div>

          {/* Şifrə */}
          <div>
            <label className="block text-sm font-semibold text-stone-700 mb-1.5">
              Şifrə <span className="text-red-500">*</span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-stone-300 bg-white rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition"
              placeholder="Ən azı 6 simvol"
              required
              minLength={6}
              data-testid="register-password-input"
            />
          </div>

          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-3 text-xs text-emerald-800 flex items-start gap-2">
            <span>✅</span>
            <span>
              <strong>Qeydiyyat müraciətiniz uğurla yekunlaşmışdır.</strong> Administrator ilə müqavilə imzalandıqdan sonra restoranınız aktiv ediləcək və QR menyunuz istifadəyə veriləcək.
            </span>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3.5 rounded-xl transition shadow-lg shadow-emerald-500/20 hover:shadow-emerald-500/40 disabled:opacity-50 disabled:cursor-not-allowed"
            data-testid="register-submit-button"
          >
            {loading ? 'Gözləyin...' : 'Qeydiyyatdan keç'}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-stone-600">
          Artıq hesabınız var?{' '}
          <Link to="/login" className="text-emerald-600 hover:text-emerald-700 font-semibold">
            Daxil olun
          </Link>
        </div>
      </div>
    </div>
  );
};
